define('uuid', [], function () {
	var floor = Math.floor,
		random = Math.random
	;


	function s4() {
		return floor(random() * 0x10000 /* 65536 */).toString(16);
	}


	/**
	 * UUID — http://ru.wikipedia.org/wiki/UUID
	 * @function uuid
	 * @returns {String}
	 */
	return function uuid(startWithLetters) {
		var id = (s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4());

		if(startWithLetters) {
			id = id.replace(/^(.*)([a-z])/i, '$2$1') || 'a';
		}

		return id;
	};
});
